<template>
  <v-dialog v-model="isVisible" persistent max-width="1200px">
    <v-card v-if="displayMode === 'loader'">
      <div class="progressWrapper">
        <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
      </div>
    </v-card>
    <v-card v-if="displayMode === 'listView'">
      <div class="headerLabel">
        <h4>Add patients to group: {{ selectedGroupName }}</h4>
      </div>
      <div class="sectionWrapper">
        <div class="searchBar">
          <input type="text" placeholder="Search Patients" v-model="searchText" />
        </div>
        <div class="tableWrapper">
          <v-data-table
            v-model="selectedPatients"
            :headers="headers"
            :items="filteredPatients"
            item-key="id"
            show-select
            sort-by="firstName"
            @toggle-select-all="_selectAllToggle"
          >
            <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
              <v-simple-checkbox :value="isSelected" @input="select($event)" />
            </template>
            <template v-slot:no-data>
              <p class="mb-4 mt-4">
                No Patients to display
              </p>
              <v-btn color="primary" outlined class="mb-4" @click="_refreshAllPatientList">
                Refresh
              </v-btn>
            </template>
          </v-data-table>
        </div>
        <div class="floatingActionBarWrapper">
          <div class="floatingActionBar">
            <button
              :class="selectedPatients.length ? 'addBtn' : 'addBtn disabled'"
              @click="_addPatientsToGroup"
            >
              Add To Group {{ selectedPatients.length ? `(${selectedPatients.length})` : "" }}
            </button>
            <button class="dismissBtn" @click="_dismiss">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
import { ApiCalls } from "../../../../api-calls";
import UserHelper from "../../../../utils/user-helper";

export default {
  name: "PatientDetailsViewer",
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    selectedGroupId: {
      type: Number,
      default: -1
    },
    selectedGroupName: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    isPromptVisible: false,
    displayMode: "loader",
    allPatients: [],
    filteredPatients: [],
    selectedPatients: [],
    searchText: "",
    headers: [
      { text: "First Name", value: "first_name" },
      { text: "Last Name", value: "last_name" },
      { text: "Phone", value: "phone" },
      { text: "Email", value: "email" }
    ]
  }),

  watch: {
    isVisible(val) {
      if (val) {
        this._reset();
        this._refreshAllPatientList();
      }
    },
    searchText() {
      this._filter();
    }
  },

  created() {},

  methods: {
    async _refreshAllPatientList() {
      try {
        let practiceId = null;
        if (this.$store.state.posActivePractice && this.$store.state.posActivePractice.value) {
          practiceId = this.$store.state.posActivePractice.value;
          this.displayMode = "loader";
          const responses = await Promise.all([
            ApiCalls.getStaticGroupPatients(this.selectedGroupId),
            ApiCalls.fetchEhrPatients(practiceId)
          ])
          const groupPatientsResponse = responses[0];
          const posPatientsResponse = responses[1];
          const allPatients = this._formatPosPatients(posPatientsResponse.data)
          const patientsInGroup = this._formatPosPatients(groupPatientsResponse.data);
          console.log('allPatients', allPatients)
          console.log('patientsInGroup', patientsInGroup)
          this.allPatients = this._filterOutExistingGroupPatients(patientsInGroup, allPatients);
          console.log('Patients not in group', this.allPatients)
          this._filter();
        }
      } catch (error) {
        console.log("error :>> ", error);
      }
      this.displayMode = "listView";
    },
    async _addPatientsToGroup() {
      try {
        this.displayMode = "loader";
        // const activeClinic = UserHelper.getActiveClinic();
        // const activePracticeId = activeClinic.PracticeID;
        // Add patients
        const formattedPatients = this.selectedPatients.map(p => ({
          FirstName: p.first_name,
          LastName: p.last_name,
          CellNumber: p.phone,
          GuarantorID: p.id
        }));

        await ApiCalls.addPatientsToGroup(
          {
            GroupID: this.selectedGroupId,
            GuarantorList: formattedPatients
          },
          this.selectedGroupId
        );
        this.$emit("on-success");
      } catch (error) {
        console.log("error :>> ", error);
        this.notification = "Unable to add patients";
        this.snackbar = true;
      }
    },
    _filterOutExistingGroupPatients(groupPatients, allPatients) {
      const groupPatientsIds = groupPatients.map(gp => gp.id);
      console.log('groupPatientsIds', groupPatientsIds)
      return allPatients.filter(p => groupPatientsIds.indexOf(p.id) === -1)
    },
    _filter() {
      if (!this.searchText.length) {
        this.filteredPatients = this.allPatients;
      } else {
        const formattedSearchText = this.searchText.trim().toLowerCase();
        this.filteredPatients = this.allPatients.filter(
          p => (p.first_name.length && p.first_name.toLowerCase().indexOf(formattedSearchText) > -1) ||
            (p.last_name.length && p.last_name.toLowerCase().indexOf(formattedSearchText) > -1) ||
            (p.phone.length && p.phone.toLowerCase().indexOf(formattedSearchText) > -1)
        );
      }
    },
    _formatPosPatients(patients) {
      return patients.map(patient => ({
        first_name: patient.FirstName,
        last_name: patient.LastName,
        phone: patient.MobileNumber,
        email: patient.Email,
        id: patient.PatientID,
        groupId: patient.GroupID,
        groupName: patient.Name
      }));
    },
    _dismiss() {
      this.$emit("on-close");
    },
    _selectAllToggle() {
      if (this.selectedPatients.length < this.allPatients.length) {
        // Currently selectable rows count is greater than selectedPatients rows
        // So select all
        this.selectedPatients = [];
        const self = this;
        this.allPatients.forEach(item => {
          self.selectedPatients.push(item);
        });
      } else {
        // Currently selectable rows count is equal to selectedPatients rows
        // So de-select all
        this.selectedPatients = [];
      }
    },
    _reset() {
      this.selectedPatients = [];
      this.searchText = "";
    }
  }
};
</script>
<style lang="scss" scoped>
.progressWrapper {
  width: 100%;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .spinner {
    margin-left: 0rem !important;
  }
  flex-direction: column;
  img {
    margin-bottom: 25px;
  }
  .dismissButton {
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    background-color: red;
    box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.2);
    color: white;
    padding: 3px 35px;
    border-radius: 15px;
    z-index: 9999;
  }
}

.sectionWrapper {
  position: relative;
  padding: 2rem;
  padding-bottom: 6rem;
  .searchBar {
    margin-bottom: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    input {
      padding: 2px 15px;
      border-radius: 5px;
      width: 40vw;
      background: rgb(231, 231, 231);
    }
  }
  .tableWrapper {
    overflow-y: scroll;
    height: 50vh;
    // display: none;
  }
  .floatingActionBarWrapper {
    position: absolute;
    width: 100%;
    bottom: 15px;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .floatingActionBar {
      width: 300px;
      height: 30px;
      box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      background: rgba(10, 10, 10, 0);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.9rem;
      font-weight: 600;
      .addBtn {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        background: rgb(18, 216, 117);
        height: 100%;
        color: rgb(255, 255, 255);

        flex: 2;
        &.disabled {
          background: rgba(110, 110, 110, 0.288);
          color: rgba(133, 133, 133, 0.562);
          cursor: not-allowed;
        }
      }
      .dismissBtn {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        height: 100%;
        background: rgb(231, 12, 12);
        color: rgb(255, 255, 255);
        flex: 1;
      }
    }
  }
}

.patientViewerOuterWrapper {
  min-height: 500px;
  max-height: 90vh;
  position: relative;
  overflow-x: hidden;

  .dismissButton {
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    background-color: red;
    box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.2);
    color: white;
    padding: 3px 35px;
    border-radius: 15px;
    z-index: 9999;
  }
}
.headerLabel {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 2rem;
  h4 {
    font-size: 1.6rem;
  }
}
</style>
